import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Usersnap_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Usersnap: Usersnap_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

